import { Tenant } from "@opendash/plugin-parse-schema";
import { Alert, Button, List, Tag } from "antd";
import Parse from "parse";
import React from "react";
type AccessPermissionProps = React.PropsWithChildren & { tenants?: Tenant[] };
const AP_CLASSNAME = "AccessPermissions";
export const DefaultAllAccessPermission = ({
  tenants,
}: AccessPermissionProps) => {
  const [logs, setLogs] = React.useState<string[]>([]);
  const createForTenants = (tenants) => {
    createAccessPermissionForTenants(tenants)
      .then(() => {
        setLogs((prev) => [
          ...prev,
          `Created All-Access AccessPermission for tenant: ${tenants.map((t) => t.get("label")).join(", ")}`,
        ]);
      })
      .catch((err) => {
        setLogs((prev) => [
          ...prev,
          `Error creating All-access AccessPermission:  ${err.message}`,
        ]);
      });
  };
  const createForTenant = (tenant) => {
    createAccessPermissionForTenant(tenant)
      .then(() => {
        setLogs((prev) => [
          ...prev,
          `Created All-Access AccessPermission for tenant: ${tenant.get("label")}`,
        ]);
      })
      .catch((err) => {
        setLogs((prev) => [
          ...prev,
          `Error creating All-access AccessPermission:  ${err.message}`,
        ]);
      });
  };
  const createGlobalAccessPermissionForAdmin = () => {
    createAccessPermissionForAdmin()
      .then(() => {
        setLogs((prev) => [
          ...prev,
          `Created global all-access AccessPermission for od-admin`,
        ]);
      })
      .catch((err) => {
        setLogs((prev) => [
          ...prev,
          `Error creating global all-access AccessPermission for od-admin:${err.message}`,
        ]);
      });
  };

  return (
    <>
      {logs.length > 0 && (
        <pre style={{ background: "#ddd", border: "1px solid grey" }}>
          {logs.map((log) => (
            <>
              {log}
              <br />
            </>
          ))}
        </pre>
      )}
      <Alert
        message={
          "Creates Access Permission for the system admin or the tenant admin. Permissions will grant users with role od-admin or od-tenant-admin-XXXXX access to all / all tenants (based on the tenant's tagPrefix) data points"
        }
      ></Alert>
      <List
        footer={
          <Button
            type="primary"
            onClick={() => {
              createGlobalAccessPermissionForAdmin();
            }}
          >
            Create All Access for od-admin
          </Button>
        }
        itemLayout="horizontal"
        dataSource={tenants}
        renderItem={(tenant) => (
          <List.Item
            actions={[
              <a
                key="for-all-tenants"
                onClick={() => {
                  createForTenant(tenant);
                }}
              >
                create for tenant
              </a>,
            ]}
          >
            <List.Item.Meta
              title={tenant.label}
              description={
                tenant.get("tagPrefix") || <Tag color="red">No tag Prefix</Tag>
              }
            />
          </List.Item>
        )}
      />
    </>
  );
};

export type { AccessPermissionProps };

async function createAccessPermissionForAdmin() {
  const pPerm = new Parse.Object(AP_CLASSNAME);
  pPerm.set("ownerGroup", true);
  pPerm.set("read", ".*");
  pPerm.set("write", ".*");
  pPerm.set("delete", ".*");
  pPerm.set("owner", ".*");
  const acl = new Parse.ACL();
  acl.setPublicReadAccess(false);
  acl.setPublicWriteAccess(false);
  acl.setRoleWriteAccess("od-admin", true);
  acl.setRoleReadAccess("od-admin", true);
  pPerm.setACL(acl);
  await pPerm.save(null, { useMasterKey: true });
}

async function createAccessPermissionForTenant(tenant: Tenant) {
  const objects = [] as Parse.Object[];

  const prefix = tenant.get("tagPrefix");
  const pPerm = new Parse.Object(AP_CLASSNAME);
  pPerm.set("ownerGroup", true);
  pPerm.set("read", ".*");
  pPerm.set("write", ".*");
  pPerm.set("delete", ".*");
  pPerm.set("owner", "^" + prefix + ".*");
  const acl = new Parse.ACL();
  acl.setPublicReadAccess(false);
  acl.setPublicWriteAccess(false);
  acl.setRoleWriteAccess("od-admin", true);
  acl.setRoleReadAccess("od-admin", true);
  acl.setRoleReadAccess("od-tenant-admin-" + tenant.id, true);
  acl.setRoleWriteAccess("od-tenant-admin-" + tenant.id, true);
  pPerm.setACL(acl);
  objects.push(pPerm);

  await Parse.Object.saveAll(objects, { useMasterKey: true });
}
async function createAccessPermissionForTenants(tenants: Tenant[]) {
  const objects = [] as Parse.Object[];
  tenants.forEach(async (tenant) => {
    const prefix = tenant.get("tagPrefix");
    const pPerm = new Parse.Object(AP_CLASSNAME);
    pPerm.set("ownerGroup", true);
    pPerm.set("read", ".*");
    pPerm.set("write", ".*");
    pPerm.set("delete", ".*");
    pPerm.set("owner", "^" + prefix + ".*");
    const acl = new Parse.ACL();
    acl.setPublicReadAccess(false);
    acl.setPublicWriteAccess(false);
    acl.setRoleWriteAccess("od-admin", true);
    acl.setRoleReadAccess("od-admin", true);
    acl.setRoleReadAccess("od-tenant-admin-" + tenant.id, true);
    acl.setRoleWriteAccess("od-tenant-admin-" + tenant.id, true);
    pPerm.setACL(acl);
    objects.push(pPerm);
  });
  await Parse.Object.saveAll(objects, { useMasterKey: true });
}
